import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { PaymentProvider } from '../classes/models/payment-provider';

@Injectable({
  providedIn: 'root'
})
export class PaymentProviderService {
  constructor(private http: HttpClient) {}

  getPaymentProvider(query = {}) {
    return this.http.get<PaymentProvider>('/api/v2/paymentProvider/one', {
      params: query
    });
  }
}
